import { processFieldNature } from "../../utils/UtilFunctions";
import { VALIDATION_MESSAGES } from "../../utils/Constants";
import { isDateInvalid } from "./formUtils";

const useFormField = ({ setValue, fieldNature, mode, dynamicFieldNature }) => {
  const { readOnly: readOnlyModes = [], hidden: hiddenModes = [] } =
    processFieldNature(fieldNature);
  let hidden = false;
  let readOnly = false;
  if (!dynamicFieldNature) {
    readOnly = readOnlyModes.includes(mode) ? true : false;
    hidden = hiddenModes.includes(mode) ? true : false;
  } else if (dynamicFieldNature === "hidden") {
    hidden = true;
  } else if (dynamicFieldNature === "readOnly") {
    readOnly = true;
  }
  const getMaxIntegerDigits = (max) => {
    if (max === undefined) return 0;
    return Math.floor(max).toString().length;
  };
  const handleTextChange = (e, maxLength, isUpperCase = true) => {
    if (!e?.target) return; // Ensure the event and target exist

  const { name, value } = e.target;
  let newValue = isUpperCase ? value.toUpperCase() : value;

  if (maxLength && newValue.length > maxLength) {
    newValue = newValue.substring(0, maxLength);
  }

  setValue(name, newValue, {
    shouldValidate: true,
  });
};

  const handleNumberChange = (name, newValue, previousValue, min, max, fractionDigits) => {
    const parsedValue = parseFloat(newValue);
  
    if (isNaN(parsedValue)) {
      setValue(name, "", { shouldValidate: true });
      return;
    }
    const formattedValue =
      typeof fractionDigits === "number" && fractionDigits > 0
        ? parsedValue.toFixed(fractionDigits)
        : newValue;
  
    if (parsedValue > max) {
      setValue(name, previousValue, { shouldValidate: true });
    } else if (
      (!min || parsedValue >= min) && 
      (!max || parsedValue <= max)
    ) {
      setValue(name, parseFloat(formattedValue), { shouldValidate: true });
    }
  };
  

  const handleNumberKeyDown = (e, value, max, setValue, name, fractionDigits) => {
    const controlKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
    if (controlKeys.includes(e.key)) return;
  
    if (e.key === "Enter") {
      if (value) {
        const formattedValue =
          typeof fractionDigits === "number" && fractionDigits > 0
            ? parseFloat(value).toFixed(fractionDigits)
            : Math.trunc(parseFloat(value));
        setValue(name, formattedValue, { shouldValidate: true });
      }
      return;
    }
  
    let currentValue = value ? value.toString().replace(/,/g, "") : "";
    const maxIntegerDigits = getMaxIntegerDigits(max);
  
    if (e.key === ".") {
      if (
        typeof fractionDigits !== "number" || 
        fractionDigits <= 0 || 
        currentValue.includes(".")
      ) {
        e.preventDefault();
      }
      return;
    }
  
    if (!isNaN(e.key)) {
      const nextValue = currentValue + e.key;
      const integerPart = nextValue.split(".")[0];
  
      if (
        integerPart.length > maxIntegerDigits || 
        parseFloat(nextValue) > max
      ) {
        e.preventDefault();
      }
      return;
    }
  
    e.preventDefault();
  };
  


  const getFieldLabel = (fieldValue, options) => {
    const filteredValues = options.filter(({ value }) => {
      return value === fieldValue && value !== "";
    });
    return filteredValues.length ? filteredValues[0].label : "";
  };
  const isObject = (value) => {
    return value instanceof Object && value.constructor === Object;
  };
  const setDropdownValue = (value, options) => {
    if (value === "" && value === options[0]?.value) {
      return options[0];
    }
    return value;
  };
  const getDropdownValue = (value) => {
    if (isObject(value) && value.value === "") {
      return value.value;
    }
    return value;
  };
  const setDate = (name, value) => {
    let newDate =
      value instanceof Date
        ? value.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
        : value
        ? `invalid:${value}`
        : null;
    setValue(name, newDate);
  };

  const getDate = (dateString) => {
    const isInvalidDate = isDateInvalid(dateString);
    return isInvalidDate || !dateString
      ? dateString?.replace("invalid:", "")
      : new Date(dateString);
  };
  const processError = (message) => {
    const [errorKey, errorValue] = message.split("_");
    const errorMessageTemplate = VALIDATION_MESSAGES[errorKey];

    if (!errorMessageTemplate) {
      return message; // Return original message if no template is found
    }

    // If there's a template and an error value, replace placeholder in template
    if (errorValue) {
      return errorMessageTemplate.replace("{1}", errorValue);
    }

    // Return the template message if there's no value to replace
    return errorMessageTemplate;
  };

  const navigateToLookup = (externalProgram, params, formData) => {
    console.log("link");
  };

  return {
    hidden,
    readOnly,
    handleTextChange,
    getFieldLabel,
    getDropdownValue,
    setDropdownValue,
    handleNumberChange,
    handleNumberKeyDown,
    setDate,
    getDate,
    processError,
    navigateToLookup,
  };
};
export default useFormField;
